import React from "react";
import { Popup } from "semantic-ui-react";

export default function TooltipIcon({
  content,
  children,
  position = "top center",
  className,
  style,
  mouseEnterDelay = 150,
  mouseLeaveDelay = 50,
  inverted = true,
  disabled = false,
  popupStyle,
  popupClassName,      // ✅ add this
  basic = true,
  flowing = true,
}) {
  return (
    <Popup
      className={popupClassName}
      content={content}
      position={position}
      inverted={inverted}
      disabled={disabled}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      basic={basic}
      flowing={flowing}
      style={{
        width: "fit-content",
        maxWidth: "none",
        minWidth: "unset",
        height: "auto",        // ✅
        minHeight: "unset",    // ✅
        padding: "10px 12px",
        ...popupStyle,
      }}
      trigger={
        <span
          className={className}
          style={{
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            ...style,
          }}
        >
          {children}
        </span>
      }
    />
  );
}
